// eslint-disable-next-line max-classes-per-file
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { CredentialProperties } from './credential-properties';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.emailCredentialProperties
})
export class EmailCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: 'Mail',
    })
    public email: string;
}

@Metamodel.model({
    name: ModelConstants.teamsCredentialProperties
})
export class TeamsCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: 'Mail',
    })
    public email: string;
}

@Metamodel.model({
    name: ModelConstants.azureBlobCredentialProperties
})
export class AzureBlobCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: 'Mail',
    })
    public email: string;
}

@Metamodel.model({
    name: ModelConstants.azureDevopsCredentialProperties
})
export class AzureDevopsCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: 'Mail',
    })
    public email: string;
}

@Metamodel.model({
    name: ModelConstants.azureDataFactoryCredentialProperties
})
export class AzureDataFactoryCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: 'Mail',
    })
    public email: string;
}
